export default "__VITE_ASSET__qr7OWR5p__"